<template>
<svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <path :fill="color" d="M36.35,65.72c-2.13,1.87-4.37,2.7-6.72,2.48-2.35-.22-4.36-1.03-6.02-2.44-1.66-1.41-2.76-3.26-3.28-5.55-.53-2.29-.1-4.61,1.3-6.97l5.45-9.14c-1.23-1.11-2.2-2.44-2.89-3.98-.7-1.54-1.05-3.19-1.05-4.93,0-3.37,1.17-6.22,3.5-8.55,2.33-2.33,5.18-3.5,8.55-3.5s6.22,1.17,8.55,3.5c2.33,2.33,3.5,5.18,3.5,8.55s-1.17,6.22-3.5,8.55c-2.33,2.33-5.18,3.5-8.55,3.5-.44,0-.88-.02-1.3-.06-.42-.04-.86-.14-1.3-.29l-5.7,9.51c-.56.9-.71,1.78-.45,2.65.25.87.69,1.55,1.31,2.06.62.51,1.36.8,2.2.88.85.08,1.67-.21,2.46-.88l31.23-26.8c2.11-1.82,4.31-2.65,6.61-2.47,2.3.17,4.3.96,5.99,2.37,1.69,1.41,2.83,3.26,3.42,5.55.6,2.29.16,4.65-1.29,7.07l-5.48,9.17c1.23,1.11,2.2,2.41,2.89,3.91.7,1.5,1.05,3.13,1.05,4.89,0,3.37-1.17,6.22-3.52,8.55-2.34,2.33-5.19,3.5-8.55,3.5s-6.2-1.17-8.53-3.51c-2.33-2.34-3.5-5.19-3.5-8.53s1.17-6.19,3.5-8.53c2.34-2.34,5.17-3.51,8.51-3.51.44,0,.87.03,1.29.08.42.05.85.15,1.29.31l5.68-9.53c.51-.9.67-1.76.5-2.57-.17-.82-.57-1.5-1.19-2.06-.62-.56-1.37-.87-2.24-.93-.88-.07-1.71.24-2.49.93l-31.23,26.76ZM35.17,41.04c1.62,0,2.99-.57,4.13-1.71,1.14-1.14,1.71-2.52,1.71-4.13s-.57-2.99-1.71-4.13c-1.14-1.14-2.52-1.71-4.13-1.71s-2.99.57-4.13,1.71c-1.14,1.14-1.71,2.52-1.71,4.13s.57,2.99,1.71,4.13c1.14,1.14,2.52,1.71,4.13,1.71ZM64.73,70.64c1.61,0,3-.57,4.15-1.71,1.15-1.14,1.72-2.52,1.72-4.13s-.57-2.99-1.72-4.13c-1.15-1.14-2.53-1.71-4.15-1.71s-2.99.57-4.11,1.71-1.69,2.52-1.69,4.13.56,2.99,1.69,4.13c1.13,1.14,2.5,1.71,4.11,1.71Z"/>
</svg>
</template>

<script>
export default {
  name: 'MomentsIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }

}
</script>

<style>

</style>
